import * as React from 'react';
const AnchorContext = React.createContext(null);
export default AnchorContext;
